/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_No_Plan_ActionInputs */

const en_us2_workout_no_plan_action = /** @type {(inputs: Workout_No_Plan_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See the plan`)
};

const pt_br2_workout_no_plan_action = /** @type {(inputs: Workout_No_Plan_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver plano`)
};

const es_419_workout_no_plan_action = /** @type {(inputs: Workout_No_Plan_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver el plan`)
};

const pt_pt2_workout_no_plan_action = /** @type {(inputs: Workout_No_Plan_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver plano`)
};

const fr_fr2_workout_no_plan_action = /** @type {(inputs: Workout_No_Plan_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir le programme`)
};

const de_de2_workout_no_plan_action = /** @type {(inputs: Workout_No_Plan_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Plan`)
};

const it_it2_workout_no_plan_action = /** @type {(inputs: Workout_No_Plan_ActionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi la scheda`)
};

/**
* | output |
* | --- |
* | "See the plan" |
*
* @param {Workout_No_Plan_ActionInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_no_plan_action = /** @type {((inputs?: Workout_No_Plan_ActionInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_No_Plan_ActionInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_no_plan_action(inputs)
	if (locale === "es-419") return es_419_workout_no_plan_action(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_no_plan_action(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_no_plan_action(inputs)
	if (locale === "de-DE") return de_de2_workout_no_plan_action(inputs)
	if (locale === "it-IT") return it_it2_workout_no_plan_action(inputs)
	return en_us2_workout_no_plan_action(inputs)
});
export { workout_no_plan_action as "workout.no_plan_action" }